export enum FinancialDetailsType {

    NotRequired = 1,
    Required = 2,
    RequiredWithFATCA = 3,
    RequiredWithCRS = 4,
    RequiredFull = 5,
}
